<template>
  <div>
    <div>
      <el-button @click="onGetXML">读取XML</el-button>
      <el-button @click="onAnalyzeXML">解析XML</el-button>
      <el-button @click="onSaveXML">保存XML</el-button>
      <el-button @click="onTest">测试数据</el-button>
      <!-- <el-button @click="onInitWs">连接WebSocket</el-button> -->
      <el-button @click="onPrint">测试打印</el-button>
      <el-button @click="onClose">关闭WebSocket</el-button>
      <el-button @click="clear">清空</el-button>
    </div>
    <div v-if="xmlDataStr" style="margin: 20px 0;height: 500px;overflow-y: auto;">{{ xmlDataStr }}</div>
    <div id="xml_data" style="display: none;" v-html="xmlDataStr"></div>
    <div style="background-color: aquamarine;" :style="[{'width':tempWidth},{'height': tempHeight}]">
      <div style="background-color: bisque;position: relative;"
        :style="[{'width':customWidth},{'height': customHeight}]">
        <div style="position: absolute;left: 20px;top: 35px;width: 300px;height: 30px;background-color: beige;">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import xmlRequest from '@/utils/xmlRequest';

export default {
  data() {
    return {
      api: require("@/api/pdd/waybills").default,
      socket: null,
      printData: {
        object_id: "",
        parent_waybill_code: null,
        print_data: null,
        waybill_code: ""
      },
      printerList: [],
      xmlDataStr: null,
      tempWidth: "",
      tempHeight: "",
      customWidth: "",
      customHeight: "",
      fileUrl: ""
    }
  },
  mounted() { },
  destoryed() {
    console.log("destoryed")
  },
  methods: {
    onTest() {
      var json_str = localStorage.getItem("printData");
      if (json_str) {
        this.printData = JSON.parse(json_str);
        this.onInitWs();
      } else {
        var data = {
          orderNumber: "240715-494990836001561",
          mallSenderAddressId: 1,
          pddPrintStandardTemplateId: 97
        };
        this.api.waybill(data).then(res => {
          this.printData.object_id = res.data[0].object_id;
          this.printData.parent_waybill_code = res.data[0].parent_waybill_code;
          this.printData.print_data = JSON.parse(res.data[0].print_data);
          this.printData.waybill_code = res.data[0].waybill_code;
          console.log("this.printData", JSON.parse(JSON.stringify(this.printData)));
          // localStorage.setItem("printData", JSON.stringify(this.printData));
          this.onInitWs();
        })
      }
    },
    onGetXML() {
      xmlRequest({
        url: '/xml/C%3A/MyDoc/yzxb_std.xml',
        method: 'get'
      }).then((response) => {
        this.xmlDataStr = response.data;
      }).catch((error) => {
        console.log("xml_error", error)
      })
    },
    onAnalyzeXML() {
      var xml_data = document.getElementById("xml_data");
      console.log("xml_data", [xml_data]);
      var page = xml_data.firstElementChild
      if (page) {
        this.tempWidth = page.attributes.width.value + "px";
        this.tempHeight = page.attributes.height.value + "px";
        console.log("宽1", this.tempWidth, "高1", this.tempHeight);
        var user = page.querySelector('[name="user"]');
        this.customWidth = user.attributes.width.value + "px";
        this.customHeight = user.attributes.height.value + "px";
        console.log("宽2", this.customWidth, "高2", this.customHeight);
      }
    },
    onSaveXML() {
      // var xml_data = document.getElementById("xml_data");
      // console.log("xml_data", [xml_data]);
      // var page = xml_data.firstElementChild
      // if (page) {
      //   var user = page.querySelector('[name="user"]');
      //   console.log("user", [user])
      // }

      var xml_data = document.getElementById("xml_data");
      var user = xml_data.querySelector('[name="user"]');

      if (user) {
        var w = user.attributes.width.value;
        var h = user.attributes.height.value;

        var xml_str = `<page height="${h}" width="${w}">
    <layout>
      <% for(i=0; i < data.list.length; i++) {%>
            <text width="<%= data.list[i].width%>" height="<%= data.list[i].height%>" left="<%= data.list[i].left%>" top="<%= data.list[i].top%>" value="<%= data.list[i].text%>" fontSize="<%= data.list[i].fontSize%>"/>
        <%}%>
    </layout>
</page>`
        const fileData = new Blob([xml_str], { type: 'application/xml' });
        this.onDownload(fileData);
      }

      // var zdy_index = this.xmlDataStr.indexOf('自定义');
      // console.log("自定义", zdy_index)

      // var start_str = '<layout name="user" height="400" width="800" >';
      // var user1_index = this.xmlDataStr.indexOf(start_str, zdy_index);
      // var user2_index = this.xmlDataStr.indexOf('</layout>', zdy_index);
      // console.log("开始", user1_index, "结束", user2_index);

      // var test1 = this.xmlDataStr.substring(user1_index + start_str.length, user2_index);
      // console.log("提取", test1);

      // var first = this.xmlDataStr.slice(0, user1_index + start_str.length);
      // var end = this.xmlDataStr.slice(user2_index);

      // var xml_text = localStorage.getItem("xml_text");
      // // console.log("xml_text", xml_text);

      // this.xmlDataStr = first + xml_text + end;

      // this.$nextTick(() => {
      //   const fileData = new Blob([this.xmlDataStr], { type: 'application/xml' });
      //   this.onDownload(fileData);
      // })
    },
    onDownload(data) {
      const elink = document.createElement("a");
      elink.download = "biaozhun_yzxb_std1";
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = URL.createObjectURL(data);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    //初始化websocket (要打开pdd打印组件这个websocket才能连接上)
    onInitWs() {
      this.socket = new WebSocket("ws://127.0.0.1:5000");
      // 添加WebSocket事件监听器
      this.socket.addEventListener("open", this.onSocketOpen);
      this.socket.addEventListener("message", this.onSocketMessage);
      this.socket.addEventListener("close", this.onSocketClose);
      this.socket.addEventListener("error", this.onSocketError);
      // console.log("初始化", this.socket);

      var custom = {};
      var data_str = localStorage.getItem("custom");
      if (data_str) {
        var custom_data = JSON.parse(data_str);
        console.log("custom_data", custom_data)
        custom_data.domData.forEach(x => {
          custom = { ...custom, [x.domId]: x.content }
        })
      }
    },
    onSocketOpen() {
      console.log("WebSocket连接已打开");
      //获取本地打印机列表
      let data = {
        cmd: "getPrinters",
        requestID: "123458976",
        version: "1.0",
      };
      // this.socket.send(JSON.stringify(data));
    },
    onSocketMessage(event) {
      console.log("收到WebSocket消息:", event.data);
      const result = JSON.parse(event.data);
      // console.log(result.cmd);
      if (result.cmd == "getPrinters") {
        this.printerList = result.printers;
      }
      if (result.cmd == "print") {
        console.log("打印信息");
      }
      // if (result.cmd == "PrintResultNotify") {
      //   console.log("打印结果通知");
      //   this.socket.close();
      // }
    },
    onSocketClose() {
      console.log("WebSocket连接已关闭");
    },
    onSocketError(event) {
      console.error("WebSocket连接错误:", event);
    },
    onPrint() {
      var custom = [];
      var data_str = localStorage.getItem("custom");
      if (data_str) {
        var custom_data = JSON.parse(data_str);
        custom = custom_data.domData.map(x => {
          return {
            width: x.width * 2,
            height: x.height * 2,
            left: x.x * 2,
            top: x.y * 2,
            fontSize: x.dataset.fontSize * 2,
            text: x.content,
          }
        })
      }
      console.log("custom", custom);

      // console.log("this.socket", this.socket);
      var data = {
        cmd: "print",
        requestID: "90E06437",
        task: {
          documents: [],
          notifyType: ["print"],
          preview: true,
          previewType: "image",
          printer: "80Label Printer",
          taskID: new Date().getTime(),
        },
        version: "1.0"
      }

      var docs = [
        {
          documentID: this.printData.waybill_code,
          contents: [
            {
              addData: {
                sender: {
                  address: {
                    city: "上海市",
                    detail: "陕西面馆",
                    district: "长宁区",
                    province: "上海市"
                  },
                  mobile: "333333333333",
                  name: "ceshi",
                }
              },
              encryptedData: this.printData.print_data.encryptedData,
              signature: this.printData.print_data.signature,
              templateUrl: this.printData.print_data.templateUrl,
              ver: this.printData.print_data.ver,
            },
            // {
            //   data: {
            //     height: 240,
            //     list: custom,
            //     waterdata: {
            //       text: "这是水印"
            //     }
            //   },
            //   templateURL: "http://192.168.10.150:9001/C%3A/MyDoc/customArea2.xml"
            //   // templateURL: this.fileUrl
            // }
          ]
        },
      ]
      data.task.documents = docs;
      console.log("开始打印", data);
      this.socket.send(JSON.stringify(data));
    },
    onClose() {
      this.socket.close()
    },
    clear() {
      this.xmlDataStr = null;
      this.tempWidth = "";
      this.tempHeight = "";
      this.customWidth = "";
      this.customHeight = "";
    }
  }
}
</script>